var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-permissions-page" }, [
    _c("div", { staticClass: "page-header" }, [
      _c(
        "div",
        { staticClass: "header-left" },
        [
          _c(
            "SupsisButton",
            { attrs: { ghost: "" }, on: { click: _vm.goBack } },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("arrow_back"),
              ]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("common.back")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title-section" }, [
            _c("h2", { staticClass: "page-title" }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("lock")]),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("tables.permissions.title")) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _vm.table
              ? _c("p", { staticClass: "page-subtitle" }, [
                  _vm._v(_vm._s(_vm.table.name)),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-right" },
        [
          _c("SupsisButton", { on: { click: _vm.onCancel } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("common.cancel")) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", loading: _vm.saving },
              on: { click: _vm.onSave },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("common.save")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.table
      ? _c("div", { staticClass: "page-content" }, [
          _c("div", { staticClass: "mode-switch-section" }, [
            _c("div", { staticClass: "mode-label" }, [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(
                  _vm._s(_vm.permissionMode === "public" ? "public" : "lock")
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mode-title" }, [
                _vm._v(_vm._s(_vm.$t("tables.permissions.mode"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mode-switch" },
              [
                _c(
                  "a-switch",
                  {
                    attrs: { disabled: _vm.saving },
                    on: { change: _vm.onModeChange },
                    model: {
                      value: _vm.isCustomMode,
                      callback: function ($$v) {
                        _vm.isCustomMode = $$v
                      },
                      expression: "isCustomMode",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        attrs: { slot: "checkedChildren" },
                        slot: "checkedChildren",
                      },
                      [_vm._v(_vm._s(_vm.$t("tables.permissions.customMode")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        attrs: { slot: "unCheckedChildren" },
                        slot: "unCheckedChildren",
                      },
                      [_vm._v(_vm._s(_vm.$t("tables.permissions.publicMode")))]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mode-description" }, [
              _vm.permissionMode === "public"
                ? _c("span", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("tables.permissions.publicModeDesc")) +
                        "\n                "
                    ),
                  ])
                : _c("span", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("tables.permissions.customModeDesc")) +
                        "\n                "
                    ),
                  ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.permissionMode === "custom"
            ? _c(
                "div",
                { staticClass: "custom-permissions" },
                [
                  _c(
                    "a-tabs",
                    {
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "a-tab-pane",
                        { key: "users", attrs: { tab: "Kullanıcılar" } },
                        [
                          _c("UserPermissionsTab", {
                            attrs: {
                              users: _vm.users,
                              departments: _vm.departments,
                              "permission-targets": _vm.permissionTargets,
                              "scope-groups": _vm.scopeGroups,
                              "current-user-id": _vm.currentUserId,
                            },
                            on: {
                              "toggle-scope": _vm.onToggleScope,
                              "activate-target": _vm.onActivateTarget,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tab-pane",
                        { key: "departments", attrs: { tab: "Departmanlar" } },
                        [
                          _c("DepartmentPermissionsTab", {
                            attrs: {
                              departments: _vm.departments,
                              users: _vm.users,
                              "permission-targets": _vm.permissionTargets,
                              "scope-groups": _vm.scopeGroups,
                            },
                            on: {
                              "toggle-scope": _vm.onToggleScope,
                              "activate-target": _vm.onActivateTarget,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }